export enum OrderStatus {
  DataIssue = "900",
  Assigned = "905",
  OnHold = "910",
  Complete = "915",
}
